import { z } from 'zod';

export const ScriptSourceUserUpload = z.object({
  type: z.literal('user-upload'),
  userUploadId: z.string(),
  userId: z.string(),
});

export type ScriptSourceUserUpload = z.infer<typeof ScriptSourceUserUpload>;
